<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-btn size="default" color="default" flat fab icon="mdi-arrow-left" class="back-button"
            @click="$router.push('/shop/home')"></v-btn>
        <v-row justify="start" class="mt-3">
            <v-col cols="12">
                <div class="d-flex align-center">
                    <h1>{{ currentCompany != null ? currentCompany.name : '' }}</h1>
                    <span class="d-flex align-center">
                        <v-icon class="me-1" icon="mdi-heart-outline"></v-icon>
                        {{ $t('entity.action.save') }}
                    </span>
                </div>

                <CustomSlider :autoplay="4000" :showPagination="true" :wrapAround="true" :imageType="'normal'"
                    :count="1" :slides="currentCompany.assets" :imageDescription="false" :clickable="false">
                </CustomSlider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h2>About</h2>
                <h3>{{ currentCompany ? currentCompany.tagline : '' }}</h3>
                <p class="paragraphed-text" v-html="currentCompany.description"></p>
                <v-btn variant="flat" size="large" color="primary" rounded="lg" class="white--text mb-2 w-100"
                    @click="() => triggerOpenContactDialog(currentCompany)">{{ $t('fairling.profile.contactRequest.getInTouch') }}</v-btn>
                <v-btn variant="outlined" size="large" rounded="lg" class="mb-2 w-100"
                    @click="$router.push(`/fairling/${route.params.merchantId}`)">{{ $t('fairling.profile.storefinder.findeling') }}</v-btn>
            </v-col>
        </v-row>
        <v-row>

            <v-col cols="12"
                v-if="currentCompany && currentCompany.productHighlights && currentCompany.productHighlights.length > 0">
                <h3>{{ $t('fairling.profile.productHighlights') }}</h3>
                <!-- <v-row >
                    <v-col cols="4">
                        <v-responsive :aspect-ratio="1/1">
                            <img class="w-100 h-100" src="https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/697c9f32-dadf-4754-939b-562d0f3d682b/STREAM_MERCHANT" alt="">
                        </v-responsive>
                    </v-col>
                    <v-col cols="4">
                        <v-responsive :aspect-ratio="1/1">
                            <img class="w-100 h-100" src="https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/697c9f32-dadf-4754-939b-562d0f3d682b/STREAM_MERCHANT" alt="">
                        </v-responsive>
                    </v-col>
                    <v-col cols="4">
                        <v-responsive :aspect-ratio="1/1">
                            <img class="w-100 h-100" src="https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/697c9f32-dadf-4754-939b-562d0f3d682b/STREAM_MERCHANT" alt="">
                        </v-responsive>
                    </v-col>
                </v-row> -->
                <CustomSlider :mouseDrag="false" :wrapAround="false" :imageType="'custom'"
                    :slides="currentCompany.productHighlights" :count="3" :customclass="'mt-5'">
                    <template v-slot="{ item }">
                        <v-responsive :aspect-ratio="1 / 1" max-height="360"
                            @click="$router.push({ name: 'CompanyProductProfile', params: { id: currentCompany.id, productId: item.id } })">
                            <img class="w-100 h-100"
                                :src="`${$cloudFrontApi}${item.image != null ? item.image.id : ''}/STREAM_MERCHANT`"
                                alt="" style="object-fit:cover;">
                        </v-responsive>
                        <v-row class="pt-1" v-if="item">
                            <v-col>
                                <div class="text-left">{{ item.title }}</div>
                            </v-col>
                        </v-row>
                    </template>

                </CustomSlider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-if="currentCompany && currentCompany.labels && currentCompany.labels.length > 0">
                <h3>{{ $t('fairling.profile.labels') }}</h3>
                <div>
                    <v-chip variant="flat" :color="label.color != '' ? label.color : '#e88be9'"
                        class="white--text colored-chip mr-2 my-1" v-for="label in currentCompany.labels"
                        :key="label.id" @click="() => triggerOpenDiscoverPopup(label)">{{
                            label.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
                </div>
            </v-col>
            <v-col cols="12">
                <span style="font-weight: bold;font-size: 16px;">{{ $t('fairling.profile.productDetails.price') }}</span><span
                    style="font-weight: bold;font-size: 16px;">€€</span>
            </v-col>
            <v-col cols="12">
                <h3>{{ $t('fairling.profile.productCategories') }}</h3>
                <div>
                    <v-chip variant="outlined" class="white--text mr-2 my-1"
                        v-for="category in currentCompany.productCategories" :key="category.id">{{
                            category.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
                </div>
            </v-col>
            <v-col cols="12">
                <h3>{{ $t('fairling.profile.productGroups') }}</h3>
                <div>
                    <div>
                        <v-chip variant="outlined" class="white--text mr-2 my-1"
                            v-for="group in currentCompany.productGroups" :key="group.id">{{
                                group.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
                    </div>
                </div>
                <v-btn v-for="(sheet, index) in currentCompany.orderSheets" :key="index" class="mt-2" target="_blank"
                    :href="`https://d2v01xjmjw73dt.cloudfront.net/${sheet}`" variant="text" prepend-icon="mdi-file-outline">{{ $t('fairling.profile.orderPDF.title') }} {{
                        currentCompany != null ? currentCompany.name : '' }} {{ currentCompany.orderSheets.length > 1 ?
                        index
                        + 1 :
                        '' }}</v-btn>

                <v-btn v-if="currentCompany.vimeoLink" class="mt-2" @click="showSheet = true" variant="text"
                    prepend-icon="mdi-video-outline">video {{
                        currentCompany != null ? currentCompany.name : '' }}</v-btn>
            </v-col>
            <v-col cols="12">
                <h3>{{ $t('fairling.profile.contact.title') }}</h3>
                <div class="ml-2">
                    <div class="d-flex align-center mb-2">
                        <v-icon size="x-small" class="me-2">mdi-home</v-icon>
                        <span style="font-size:14px">{{ currentCompany.address != null ? currentCompany.address.street :
                            ''
                            }}
                            & {{ currentCompany.address != null ? currentCompany.address.city : '' }} ,
                            {{ currentCompany.address != null ? currentCompany.address.country : '' }}</span>
                    </div>
                    <div class="d-flex align-center mb-2">
                        <v-icon size="x-small" class="me-2">mdi-card-account-details</v-icon>
                        <span style="font-size:14px">{{ currentCompany.address != null ? currentCompany.address.postCode
                            :
                            '' }}</span>
                    </div>
                    <div class="d-flex align-center mb-2" v-if="[typeof currentCompany.phoneNumber] != 'undefined'">
                        <v-icon size="x-small" class="me-2">mdi-phone</v-icon>
                        <span style="font-size:14px">{{ currentCompany != null ? currentCompany.phoneNumber : ''
                            }}</span>
                    </div>
                    <div class="d-flex align-center mb-2">
                        <v-icon size="x-small" class="me-2"
                            v-if="[typeof currentCompany.facebookUrl] != 'undefined'">mdi-facebook</v-icon>
                        <a class="mr-1" style="font-size:14px" target="_blank" :href="currentCompany.facebookUrl"
                            v-if="[typeof currentCompany.facebookUrl] != 'undefined'">{{ $t('global.form.facebook') }}</a>
                        <v-icon size="x-small" class="me-2"
                            v-if="[typeof currentCompany.instagramUrl] != 'undefined'">mdi-instagram</v-icon>
                        <a style="font-size:14px" target="_blank" :href="currentCompany.instagramUrl"
                            v-if="[typeof currentCompany.instagramUrl] != 'undefined'">{{ $t('global.form.instagram') }}</a>
                    </div>
                    <div class="d-flex mb-2 flex-column"
                        v-if="[typeof currentCompany.externalResources] != 'undefined' && currentCompany.externalResources.length >= 1">
                        <h4>{{ $t('global.form.youCanAlsoFindUsOn') }}</h4>
                        <template v-for="resource in currentCompany.externalResources" :key="resource.id">
                            <div>
                                <v-icon size="x-small" class="me-2">mdi-cart</v-icon>
                                <a class="mr-1" style="font-size:14px" target="_blank" :href="resource.url"> {{
                                    resource.name }} </a>
                            </div>
                        </template>
                    </div>
                </div>
            </v-col>
            <v-col cols="12">
                <h2>{{ $t('fairling.profile.findeling-streamItems') }}</h2>
                <MasonryGrid :items="merchantStreams" :max-columns="3" :min-columns="1"
                    v-if="Array.isArray(merchantStreams) && merchantStreams.length >= 1">
                    <!-- <template v-slot="{ item }">
                        <CustomNewsCard :img="item.image" :item="item" :title="item.headline" :openPostPopup="() => openPost(item)">
                        </CustomNewsCard>
                    </template> -->
                    <template #default="{ item }">
                        <CustomPostCard :item="item" />
                    </template>
                </MasonryGrid>
                <v-card color="default" class="" elevation="0" v-else>
                    <v-card-text class="py-14 px-0 text-center">
                        <p class="text-center f-16">
                            {{ $t('fairling.profile.noStreams') }}
                        </p>
                    </v-card-text>
                </v-card>

            </v-col>
        </v-row>



        <CustomTopSheetDialog v-model="showSheet" :width="600"
            :title="`Video ${currentCompany != null ? currentCompany.name : ''}`">
            <div class="video-wrapper">
                <iframe :src="`${$vimeoUrl}${currentCompany.vimeoLink}`" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </CustomTopSheetDialog>
    </v-container>
</template>

<script>
import { ref, inject } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import CustomPostCard from '@/components/custom/CustomPostCard.vue';
import CustomSlider from '@/components/custom/CustomSlider.vue';
import CustomSliderImage from '@/components/custom/CustomSliderImage.vue';
import MasonryGrid from '@/components/custom/MasonryGrid.vue';
import { useRoute } from 'vue-router'

export default {
    components: {
        CustomTopSheetDialog,
        CustomSlider,
        CustomSliderImage,
        CustomPostCard,
        MasonryGrid
    },
    setup() {
        // const showSheet = ref(false);
        const route = useRoute()
        const config = {
            itemsToShow: 3
        }
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const openText = ref(false);
        const toggleText = () => {
            openText.value = !openText.value; // Toggle the open state
        }

        const openDiscoverPopup = inject('openDiscoverPopup');

        const triggerOpenDiscoverPopup = (label) => {
            openDiscoverPopup(label);
        }


        const openContactDialog = inject('openContactDialog')

        const triggerOpenContactDialog = (merchant) => {
            openContactDialog(merchant);
        }
        return {
            // showSheet:false,
            config,
            openText,
            toggleText,
            route,
            selectedLanguage,
            triggerOpenContactDialog,
            triggerOpenDiscoverPopup
        };
    },

    data() {
        return {
            currentCompany: {},
            merchantStreams: [],
            htmlContent: "<strong>Hello, World!</strong> This is <em>raw HTML</em>.",
            showSheet: false,
            items: [
                "Kundenmagnet",
                "Image Booster",
                "Must-Have",
                "Geheimtipp",
                "Margen-Held",
                "PR-Star",
                "Kundenliebling",
                "Durchstarter",
            ],
            images: [
                "https://picsum.photos/200/300", "https://picsum.photos/300/300", "https://picsum.photos/500/300"
            ]
        }
    },

    mounted() {
        if (this.route.params.id == 'undefined' || this.route.params.id == "" || this.route.params.id == null) {
            this.fetchCompanyProfile();
        } else {
            this.fetchMerchantProfile()
        }
        this.fetchMerchantStreams();
    },

    methods: {
        fetchMerchantProfile() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            var _this = this;
            this.$axios.get("/merchant/stream/" + this.route.params.id, {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },

            })
                .then(this.companyFetched)
                .catch(error => {
                    
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if ( error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        _this.$router.replace('/login');
                        // Optionally log the user out or redirect to login page
                    } else if (error.response && error.response.status === 500) {
                        _this.$router.push('/404')
                    }
                });
        },
        fetchCompanyProfile() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            var _this = this;
            this.$axios.get("/merchant/t/" + this.route.params.merchantId, {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },

            })
                .then(this.companyFetched)
                .catch(error => {
                    
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if ( error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        _this.$router.replace('/login');
                        // Optionally log the user out or redirect to login page
                    } else if (error.response && error.response.status === 500) {
                        _this.$router.push('/404')
                    }
                });

        },
        companyFetched(response) {
            this.currentCompany = response.data.data;
        },
        fetchMerchantStreams() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            var _this = this;
            this.$axios.get("/merchants/" + this.route.params.merchantId + "/streams", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
            })
                .then(this.merchantStreamsFetched)
                .catch(error => {
                    
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if ( error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        _this.$router.replace('/login');
                        // Optionally log the user out or redirect to login page
                    } else if (error.response && error.response.status === 500) {
                        _this.$router.push('/404')
                    }
                });

        },
        merchantStreamsFetched(response) {
            this.merchantStreams = response.data.data;
        }
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
}

.description-wrapper {
    position: relative;
}


a {
    text-decoration: none;
}

.description-text {
    display: block;
    max-height: 200px;
    /* Adjust the height based on your design */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    transition: max-height 0.3s ease-in-out;
    font-size: 14px;
}

.description-text.truncated {
    max-height: 200px;
    /* Limit text height when truncated */
}

.description-text:not(.truncated) {
    max-height: none;
    /* Allow full text to show when toggled */
}

.text-link {
    text-decoration: none;
    color: #1e88e5;
    cursor: pointer;
    float: right;
}

.text-link:hover {
    text-decoration: underline;
}

.back-button {
    position: absolute;
    left: 250px;
}

.back-button .v-icon {
    width: 20px !important;
    height: 20px !important;
    min-width: none;
    min-height: none;
}
</style>

<style>
/*.dialog-list-item {
    min-height: 30px !important;
    background-color: transparent !important;
  }
  
  */
.colored-chip {
    color: white !important;
}

.video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 ratio */
    height: 0;
    overflow: hidden;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}



.share-hint,
.descrption-text {
    font-size: 14px !important;
}

h1 {
    font-size: 36px !important;
    ;
}

h4 {
    font-size: 16px !important;
    font-weight: 700;
}

.f-16 {
    font-size: 16px !important;
}

.edit-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
}

.logo-sheet {
    background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
    background-size: cover;
}
</style>